export const rawData = "https://api.covid19india.org/raw_data.json";
export const statesDaily = "https://api.covid19india.org/states_daily.json";
export const dataUrl = "https://api.covid19india.org/data.json";
export const stateDistrictWise =
  "https://api.covid19india.org/state_district_wise.json";
